import {
    Box,
    Dialog,
    DialogActions,
    DialogContent, DialogTitle, Step, StepLabel, Stepper,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ButtonExit from "../../button/ButtonExit";
import ButtonAdd from "../../button/ButtonAdd";
import SignJobService from "../../../../API/orders/job/SignJobService";
import SettingsSignJobTable from "./SettingsSignJobTable";
import JobMetricOrganizationTable from "../prodaction/jobmetricorganization/JobMetricOrganizationTable";
import {useLocation} from "react-router-dom";
import ButtonBack from "../../button/ButtonBack";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {orderJobType} from "../../../../data/OrderJobType";
import {JobMetricOrganizationFilterData} from "../../../../data/FilterTables/JobMetricOrganizationFilterData";

const AddSignJobMetricModal = ({
                                   open, onClose, handleSubmit, title, jobMetric, baseCurrency,
                                   alternativeCurrency, handleModalAlert
                               }) => {
    const pathname = useLocation().pathname
    const [activeStep, setActiveStep] = useState(0)
    const [selectedJobMetricOrganization, setSelectedJobMetricOrganization] = useState({})
    const [data, setData] = useState([])
    const [selectedString, setSelectedString] = useState({})
    const [filteredData, setFilteredData] = useState([])
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: jobMetric?.length,
        searchData: ""
    })
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, JobMetricOrganizationFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [JobMetricOrganizationFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`${pathname}-modal`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}-modal`]?.pageSize
        const searchQuery = pagesData[`${pathname}-modal`]?.searchQuery

        return {searchQuery, pageSize}
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        handleSearchQuery(searchQuery, jobMetric, pageSize)
        setTypeList(OrderUtil.getListFieldByEnum(jobMetric, 'orderJobType', orderJobType));
    }, [open])

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    const handleClose = () => {
        onClose()
        setActiveStep(0)
        setSelectedJobMetricOrganization({})
        setSelectedString({})
    }
    const back = () => {
        setActiveStep(activeStep - 1);
    }
    const submit = () => {
        if (activeStep === 0) {
            SignJobService.getForType(selectedJobMetricOrganization.id, "SALARY")
                .then(function (response) {
                    setData(response?.data)
                    handleSearchQuery(globalFilter, response?.data)
                    setActiveStep(1)
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })

        } else {
            handleSubmit(selectedString)
        }
    }
    return <Dialog open={open} PaperProps={{
        style: {
            minWidth: activeStep === 0 ? "1650px" : "1400px",
            height: "1100px",
        }
    }}>
        <Box style={{
            padding: 40,
            display: "flex",
            flexDirection: "column",
            gap: 16,
            alignItems: "center"
        }}>
            <DialogTitle sx={{
                color: (theme) => theme.palette.text.main,
                margin: "auto",
                padding: 0,
                fontSize: 24,
                fontWeight: 700
            }}>{title}</DialogTitle>
            <Stepper
                alternativeLabel
                style={{width: "100%"}}
                activeStep={activeStep}
            >
                {["Наименование работ", "Метрики работ"].map((label) => (
                    <Step key={label} sx={{
                        "& .MuiStepConnector-root": {
                            top: "20px",
                            left: 'calc(-50% + 30px)',
                            right: "calc(50% + 30px)"
                        }
                    }}>
                        <StepLabel sx={{
                            ".MuiSvgIcon-root": {
                                fontSize: 40,
                                color: "#737478",
                                "&.Mui-active": {
                                    color: "#3B8BEC",
                                }
                            },
                            "& .MuiStepLabel-label": {
                                fontSize: 18,
                                "&.Mui-active": {
                                    fontWeight: 700,
                                }
                            },

                        }}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
        <DialogContent sx={{}}>
            {activeStep === 0
                ?
                <Box
                    style={{width: "100%"}}
                >
                    <JobMetricOrganizationTable
                        data={jobMetric}
                        isModal={true}
                        selectedString={selectedJobMetricOrganization}
                        setSelectedString={setSelectedJobMetricOrganization}
                        baseCurrency={baseCurrency}
                        alternativeCurrency={alternativeCurrency}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        columnAdded={false}
                        handleModalAlert={handleModalAlert}
                        globalFilter={globalFilter}
                        handleSearchQuery={handleSearchQuery}
                        filteredData={filteredData}
                        columnsFilter={columnsFilter}
                        typeList={typeList}
                    />
                </Box> :
                <Box
                    style={{width: "100%"}}
                >
                    <SettingsSignJobTable
                        data={data}
                        isModal={true}
                        selectedString={selectedString}
                        setSelectedString={setSelectedString}
                        handleModalAlert={handleModalAlert}/>
                </Box>}
        </DialogContent>
        <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
            <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={back}/>} </Box>
            <Box>
                <ButtonExit text={"Выйти"} onClick={handleClose}/>
                <ButtonAdd text={"Выбрать"} onClick={submit}
                           disabled={(activeStep === 0 && !selectedJobMetricOrganization.id) || (activeStep === 1 && !selectedString.id)}/>
            </Box>
        </DialogActions>
    </Dialog>
}
export default AddSignJobMetricModal